import { render, staticRenderFns } from "./appwgt.vue?vue&type=template&id=bfbefaf8&scoped=true&"
import script from "./appwgt.vue?vue&type=script&lang=js&"
export * from "./appwgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbefaf8",
  null
  
)

export default component.exports